
import React, { memo, useState } from 'react';
import cx from 'classnames';
import _isEmpty from 'lodash.isempty';
import { Checkbox, Icon, RadioButton, Text } from '../../../../ui-kit';
import {
  APPROVED,
  PENDING,
  REJECTED } from
'../../../Addons/constants/statuses';
import {
  ADDONS_TO_BE_APPROVED,
  BURN_IN_CAPTIONS,
  RUSH_EDIT } from
'../../../Addons/constants/addonsToBeApproved';

import '../../styles/_addon-view.scss';

















const STATUSES = { PENDING: 'Pending' };

function AddonView({
  addonStatus,
  addonType,
  iconName,
  text,
  price,
  value,
  suffixDagger,
  subText,
  isDescriptionWrapped,
  onChangeAddonStatus,
  shouldShowActions = false,
  isNewDesign
}) {
  const [status, setStatus] = useState(addonStatus || PENDING);
  const shouldBeApproved = ADDONS_TO_BE_APPROVED.includes(addonType);
  const changeAddonStatus = (newStatus) => {
    if (onChangeAddonStatus) {
      onChangeAddonStatus({ addonType, addonStatus: newStatus, value });
      setStatus(newStatus);
    }
  };

  function getApprovedAddonsPrice(str) {
    if (_isEmpty(str)) return 0;
    const regex = /-?\d+(\.\d+)?/g;
    const matches = str.toString().match(regex);
    return matches ? matches.map(Number)[0] : 0;
  }

  const getApprovedSRT = getApprovedAddonsPrice(price);

  return (
    <div className="addon-view">
      <div className="addon-view__info">
        <div className={cx('addon-view__info__name', { 'addon-view__info__name--wrapped': isDescriptionWrapped })}>
          <div className="addon-view__info__name-block">
            <Icon className="addon-view__info__name-icon" name={iconName} size={20} color="denim" />

            <Text
              className="addon-view__info__name-text"
              noMargin
              suffixDagger={getApprovedSRT === 0 && suffixDagger}>

              {text}
            </Text>

            {shouldShowActions && shouldBeApproved && status === PENDING &&
            <Text className="addon-view__info__status" noMargin>{STATUSES[status]}</Text>}

          </div>
        </div>
        <div className="addon-view__info__name-description">
          <Text noMargin caption={isNewDesign}>{subText}</Text>
        </div>
        {(!shouldShowActions || !shouldBeApproved) &&
        <Text className="addon-view__info__price" label noMargin>{price}</Text>}

      </div>

      {shouldShowActions && shouldBeApproved &&
      <div className="addon-view__actions">
          {addonType === RUSH_EDIT &&
        <>
              <RadioButton
            onChange={() => changeAddonStatus(APPROVED)}
            selected={status === APPROVED}>

                Accept
              </RadioButton>
              <RadioButton
            onChange={() => changeAddonStatus(REJECTED)}
            selected={status === REJECTED}>

                Deny
              </RadioButton>
            </>}


          {
        addonType === BURN_IN_CAPTIONS &&
        <Checkbox
          checked={status === APPROVED}
          onChange={() => changeAddonStatus(status === APPROVED ? PENDING : APPROVED)}>

              Applied
            </Checkbox>}


        </div>}

    </div>);

}

export default memo(AddonView);